import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import AmbassadorsVerifiedData from "../AmbassadorVerifiedData/AmbassadorVerifiedData";

const COPY = {
  title: "Verified Ambassadors",
  subtitle: "You Can See Detail About Verified Ambassadors",
  searchPlaceholder: "Search Here",
};

const AmbassadorsVerified = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <AmbassadorsVerifiedData driverData={items} />
    </AdminPage>
  );
};

export default AmbassadorsVerified;
